import { AverageEmoji, DisappointedEmoji, HappyEmoji, SadEmojis, SmilingEmoji } from 'assets/svg';
import { motion } from 'framer-motion';
import { Tooltip } from 'components';
import React from 'react';

const ReviewField = ({ field, form, label }) => {
  const { name, value } = field;
  const { setFieldValue } = form;

  const emojis = [
    { emoji: DisappointedEmoji, value: "Disappointed" },
    { emoji: SadEmojis, value: "Poor" },
    { emoji: AverageEmoji, value: "Average" },
    { emoji: HappyEmoji, value: "Good" },
    { emoji: SmilingEmoji, value: "Fantastic" },
  ];

  const handleClick = (emojiValue) => {
    setFieldValue(name, emojiValue);
  };

  return (
    <div className="flex flex-col items-start justify-between gap-2 min-h-[100px]">
      <p className="ml-2 text-black dark:text-white">{label}</p>
      <div className="flex items-center p-0 w-full justify-between min-h-[80px]">
        {emojis.map((elem, index) => (
          <motion.div
            key={index}
            className={`flex justify-center items-center cursor-pointer ${
              value === elem.value ? "bg-[#ecf0fa] rounded-full pt-1" : ""
            }`}
            onClick={() => handleClick(elem.value)}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            animate={{ scale: value === elem.value ? 1.1 : 1 }}
            style={{
              width: '56px',
              height: '56px',
            }}
          >
            <Tooltip message={elem.value}>
              <img src={elem.emoji} alt={elem.value} className="" />
            </Tooltip>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ReviewField;
